import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import Advisors from "@/components/landing/Advisors";
import Footer from "@/components/landing/Footer";
import Privacy from "@/components/landing/Privacy";
import { AuthProvider } from "@/app/AuthContext";
import AppShell from "@/app/AppShell";
import AuthCallback from "@/app/AuthCallback";
import Auth from "@/app/pages/Auth";
import HomePage from "@/app/pages/Home";
import Cases from "@/app/pages/Cases";
import NewCase from "@/app/pages/NewCase";
import Workspace from "@/app/pages/Workspace";
import Archive from "@/app/pages/Archive";
import ArchiveDetail from "@/app/pages/ArchiveDetail";
import Profile from "@/app/pages/Profile";
import Account from "@/app/pages/Account";

function Landing() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Chapters />
        <Advisors />
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="cases" element={<Cases />} />
        <Route path="new" element={<NewCase />} />
        <Route path="case/:id" element={<Workspace />} />
        <Route path="archive" element={<Archive />} />
        <Route path="archive/:pcn" element={<ArchiveDetail />} />
        <Route path="profile" element={<Profile />} />
        <Route path="account" element={<Account />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App" data-testid="boardroom-landing">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
